function toggleWidget(e) {
  e.preventDefault();
  document.querySelector('.widget-container').classList.toggle('open');
  document.querySelector('body').classList.toggle('noscroll');
  window.dispatchEvent(new Event('resize'));
  console.log('TW');
  toggleZohoChat();
}

function toggleCollectionWidget(e) {
  // if(e.target.classList.contains('.widget-header__back-button') || e.target.closest('.widget-header__back-button')) {

  // }
  e.preventDefault();
  e.target.closest('.grid__item').querySelector('.widget-container').classList.toggle('open');
  if(e.target.closest('.grid__item').querySelector('.widget-container').classList.contains('open')) {
    e.target.closest('.grid__item').querySelector('.tab-pane').classList.add('active');
    e.target.closest('.grid__item').querySelector('.nav-tabs li').classList.add('active');
  }
  document.querySelector('body').classList.toggle('noscroll');
  window.dispatchEvent(new Event('resize'));
  console.log('TW');
  toggleZohoChat();
}

$zoho.salesiq.ready = function() {
  toggleZohoChat();
}

function toggleZohoChat() {
  if($('.widget-container').hasClass('open')) {
    $zoho.salesiq.floatbutton.visible("hide");
  }
  else {
    $zoho.salesiq.floatbutton.visible("show");
  }
}

function openTab(index) {
  document.querySelector(`.widget-container.open #tab-${index}-link`).click();
  window.dispatchEvent(new Event('resize'));
}

function engravingCollapsible() {
  $('.engraving-checkbox').change(function(){
    $('.engraving-content').slideToggle('slow');
  });
}

window.onload = function () {
  engravingCollapsible();
  attachOptionListeners();
  attachFontChangeListener();
  customEvents.init();
  document.addEventListener('sizeChanged', function() {
    updateTotal();

  });

  showSuccessMessageOnImageUpload();
  removeSuccessMessage();
  initTooltipModal();

}

var prevOptionValues = {
  sizeChanged: null,
  extrasChanged: null
};

var customEvents = {
  events: {
    sizeChanged: {
      event: null,
      handler: function onSizeChanged() {
        console.log("sizeChanged");
        updateBaseOptions();
        updateSizePrice();
        variantImageSelector();
        updateTotal();
        updateMainImage();
      }
    },
    warrantyChanged: {
      event: null,
      handler: function onWarrantyChanged() {
        console.log("warrantyChanged");
        updateWarrantyPrice();
        updateTotal();
      }
    },
    baseChanged: {
      event: null,
      handler: function onBaseChanged() {
        console.log("baseChanged");
        updateBasePrice();
        updateTotal();
      }
    },
    personsChanged: {
      event: null,
      handler: function onPersonsChanged() {
        console.log("personsChanged");
        updatePersonsPrice();
        updateTotal();
      }
    }
  },
  init: function() {
    Object.keys(customEvents.events).forEach(function(eventName) {
      customEvents.events[eventName].event = createCustomWidgetEvent(eventName);
      attachCustomEventListener(eventName, customEvents.events[eventName].handler);
      console.log(eventName);
      console.log(customEvents.events[eventName].handler);
      console.log("INITIALIZED EVENT:", customEvents.events[eventName].event);
    }) 
  }
}

function createCustomWidgetEvent(name) {
  return new Event(name);
}

function attachCustomEventListener(event, handler) {
  document.addEventListener(event, handler, false);
}

function onOptionChanged(event, option) {
  console.log('option changed');
  console.log("this", option);
  if(event) {
    (prevOptionValues[event]) ? console.log(prevOptionValues[event].value) : null;
    if (this !== prevOptionValues[event]) {
        prevOptionValues[event] = this;
    }
    console.log("EVENT:", event);
    console.log(option.value);
    
    // Dispatch the event.
    document.dispatchEvent(customEvents.events[event].event);
  }
}

function attachOptionListeners() {
  var sizeOptions = document.querySelectorAll('.radio-group--size');
  for (var i = 0; i < sizeOptions.length; i++) {
    sizeOptions[i].addEventListener('change', function(){ onOptionChanged('sizeChanged', this)});
  }
  var baseOptions = document.querySelectorAll('.radio-group--light-base');
  for (var i = 0; i < baseOptions.length; i++) {
    baseOptions[i].addEventListener('change', function(){ onOptionChanged('baseChanged', this)});
  }
  var personOptions = document.querySelectorAll('.radio-group--persons');
  for (var i = 0; i < personOptions.length; i++) {
    personOptions[i].addEventListener('change', function(){ onOptionChanged('personsChanged', this)});
  }
  var warrantyOptions = document.querySelectorAll('.radio-group--warranty');
  for (var i = 0; i < warrantyOptions.length; i++) {
    warrantyOptions[i].addEventListener('change', function(){ onOptionChanged('warrantyChanged', this)});
  }
  var $engravingInput = $('.engraving-checkbox');
  $engravingInput.on('change', function() {
    updateEngravingPrice();
    updateTotal();
  });
}

let prices = {
  size: 0,
  base: 0,
  engraving: 0,
  warranty: 0,
  persons: 0
}

function updateSizePrice() {
  prices.size = parseFloat($('.radio-group--size:checked').attr('data-price'));
}

function updateBasePrice() {
  let basePrice = $('.radio-group--light-base:checked').attr('data-price');
  prices.base = basePrice ? parseFloat(basePrice) : 0;
}

function updatePersonsPrice() {
  let personsPrice = $('.radio-group--persons:checked').attr('data-price');
  prices.persons = personsPrice ? parseFloat(personsPrice) : 0;
}

function updateWarrantyPrice() {
  let warrantyPrice = $('.radio-group--warranty:checked').attr('data-price');
  prices.warranty = warrantyPrice ? parseFloat(warrantyPrice) : 0;
}

function updateEngravingPrice() {
  prices.engraving = getEngravingPrice();
}

function updateTotal() {
  let sizePrice = prices.size;
  let engravingPrice = prices.engraving;
  let basePrice = prices.base;
  let warrantyPrice = prices.warranty;
  let personsPrice = prices.persons;
  let totalPrice = sizePrice + engravingPrice + basePrice + warrantyPrice + personsPrice;
  console.log("SIZE PRICE:", sizePrice);
  console.log("BASE PRICE:", basePrice);
  console.log("PERSONS PRICE:", personsPrice);
  console.log("TOTAL PRICE:", totalPrice);
  $('.widget-total-amount').text(totalPrice.toFixed(2));
}

function getEngravingPrice() {
  return 0;
  let engravingSelected = $('.engraving-checkbox:checked').length > 0;
  if(engravingSelected){
    let engravingPrice = parseFloat($('.engraving-checkbox:checked').attr('data-price'));
    return engravingPrice;
  }
  else {
    console.log("Not sel");
    return 0;
  }
}

function updateBaseOptions() {
  let selectedSize = $('.widget-container.open .radio-group--size:checked').attr('value');
  $('.widget-container.open .light-base-option-0').prop('checked', true);
  updateBasePrice();
  $('.widget-container.open .base-option').each(function(_i, option){
    if($(option).attr('data-size-variant') !== selectedSize) {
      $(option).hide();
    }
    else {
      $(option).show();
    }
  });
}

function attachFontChangeListener() {
  $('.engraving-font').on('change', function() {
    updateEngravingFont(this.value);
  });
  $('.engraving-font-mobile').on('change', function() {
    updateEngravingFontMobile(this.value);
  });
}

function updateEngravingFont(font) {
  $('.widget-container.open .engraving-input').css('font-family', font);
}

function updateEngravingFontMobile(font) {
  $('.widget-container.open .engraving-input-mobile').css('font-family', font);
}

function showSuccessMessageOnImageUpload() {
  $(document).on('click', '.cl-po--preview-crop>button:nth-child(3)', function() {
    let successMessageHtml = '<p class="image-upload-success-message">Image upload successful!</p>'
    $('.cl-po--upload-files').append(successMessageHtml);
  });
}

function removeSuccessMessage() {
  $(document).on('click', '.cl-po--remove', function() {
    $('.image-upload-success-message').remove();
  });

  $(document).on('click', '.cl-po--upload-button', function() {
    $('.image-upload-success-message').remove();
  });
}

/*
/====== Data schema ======/

  let data = {
    items: [
      {
        "id": variantId,
        "quantity": quantity,
        "properties": itemProperties
      },
    ]
  }
*/

// let lineItemProperties = {
//   upload: getUploadLink(),
//   engravingText: getEngravingText(),
//   engravingFont: getEngravingFont()
// }

function addToCart() {
  var items = getSelectedOptions();
  let data = {
    items: items
  }

  fetch('/cart/add.js', {
    body: JSON.stringify(data),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest'
    },
    method: 'POST'
  }).then((response) => {
    return response.json();
  }).then((json) => {
    /* yay! our products were added - do something here to indicate to the user */
    console.log('products', json);
    window.location.href = "/cart";
  }).catch((err) => {
    /* uh oh, we have error. */
    console.error(err)
  });
}

function getSelectedOptions() {
  let options = {
    warranty: {
      id: getWarrantyVariant(),
      quantity: 1
    },
    base: {
      id: getBaseVariant(),
      quantity: 1
    },
    persons: {
      id: getPersonsVariant(),
      quantity: 1
    },
    size: {
      id: getSizeVariant(),
      quantity: 1,
      properties: {
        upload: getUploadLink(),
        preview: getOriginalImageLink(),
        'Engraving Font': getEngravingFont(),
        'Engraving Text': getEngravingText()
      }
    },
    // engraving: {
    //   id: getEngravingVariant(),
    //   quantity: 1,
    //   properties: {
    //     engravingFont: getEngravingFont(),
    //     engravingText: getEngravingText()
    //   }
    // }
  }

  debugger
  return filterOptions(options);
}

function filterOptions(options) {
  let items = [];
  for(option in options) {
    if(options[option].id !== null) {
      items.push(options[option]);
    }
  }
  console.log("ITEMS:", items);
  return items;
}

function getSizeVariant() {
  var size = $('.widget-container.open .radio-group--size:checked').attr('data-variant');
  $('#size-id').attr('value', size);

  console.log($('.widget-container.open #size-id').val());
  return $('.widget-container.open .radio-group--size:checked').attr('data-variant');
}

function getBaseVariant() {
  var base = $('.widget-container.open .radio-group--light-base:checked').attr('data-variant');
  $('#base-id').attr('value', base);
  if(base === 'none' || base == null) {
    return null;
  }
  else {
    return base;
  }
}

function getPersonsVariant() {
  var persons = $('.widget-container.open .radio-group--persons:checked').attr('data-variant');
  if(persons == null || persons == 'none') {
    return null;
  }
  else {
    return persons;
  }
}

function getWarrantyVariant() {
  var warranty = $('.widget-container.open .radio-group--warranty:checked').attr('data-variant');
  if(warranty === 'none' || warranty == null) {
    return null;
  }
  else {
    return warranty;
  }
}

function getEngravingVariant() {
  var engravingSelected = $('.widget-container.open .engraving-checkbox:checked').length > 0;
  if(engravingSelected) {
    return $('.widget-container.open .engraving-checkbox:checked').attr('data-variant');
  }
  else {
    return null;
  }
}

function getUploadLink() {
  return $('.widget-container.open input[name="properties[option_2]"]').first().attr('value');
}

function getOriginalImageLink() {
  return $('.widget-container.open input[name="properties[_original]"]').first().attr('value');
}

function getEngravingText() {
  if($('.widget-container.open .engraving-input').length > 0 && $('.widget-container.open .engraving-input')[0].value.trim().length > 0) {
    return $('.widget-container.open .engraving-input')[0].value;
  }
  else if($('.widget-container.open .engraving-input-mobile').length > 0 && $('.widget-container.open .engraving-input-mobile')[0].value.trim().length > 0) {
    return $('.widget-container.open .engraving-input-mobile')[0].value
  }
}

function getEngravingFont() {
  if($('.widget-container.open .engraving-font').length > 0 && $('.widget-container.open .engraving-font')[0].value.trim().length > 0) {
    return $('.widget-container.open .engraving-font')[0].value;
  }
  else if($('.widget-container.open .engraving-font-mobile').length > 0 && $('.widget-container.open .engraving-font-mobile')[0].value.trim().length > 0) {
    return $('.widget-container.open .engraving-font-mobile')[0].value;
  }
}

function createItem(variantId, itemProperties) {
  return {
    "id": variantId,
    "quantity": 1,
    "properties": itemProperties
  }
}

function initTooltipModal() {
  $('.widget-container.open .tooltip-trigger').click(function(event) {
    var target = $(event.target).closest('.tooltip-trigger').attr('data-tooltip-modal');
    console.log('target', target);
    var targetImageElement = $('.modal-image' + '.' + target);
    console.log('targetIE', targetImageElement);
    $('.modal-image').hide();
    $(targetImageElement).show();
    $('.modal-with-overlay').show();
  });

  $('.modal-with-overlay').click(function(e) {
    console.log(e.target);
    if($(e.target).parents('.modal').length === 0) {
      $('.modal-with-overlay').hide();
    }
  });

  $('.modal-close').click(function() {
    $('.modal-with-overlay').hide();
  });
}

function variantImageSelector() {
  let selectedSize = $('.radio-group--size:checked').attr('data-variant-title');
  // $('select.cl-po--input').val(selectedSize);
  // console.log("Select element value after:", $('select.cl-po--input').val());
  // console.log("Selected size: ",selectedSize);
  // $('select.cl-po--input').trigger('change');
  let sizeID = $('.radio-group--size:checked').attr('value');
  console.log("Selected ID: ",sizeID);

  let radioToSelect = $(`.cl-po--radio-item .cl-po--input[value="${selectedSize}"]`);
  console.log("Radio to select", radioToSelect);
  radioToSelect.trigger('click');
  // let $variantIDs = $('form[action="/cart/add"] input[name="id"]');
  // $variantIDs.val(sizeID);
  // $variantIDs.trigger('change');
  // $('.product-form form').trigger('change');
  // $('form[action="/cart/add"] input[name="id"]').trigger('change');

  // let formVariantInputs = $('.js product-form__input input');
  // let inputToSelect = formVariantInputs.filter(function(input) {
  //   return $(input).attr('value') === selectedSize;
  // });
  // formVariantInputs.prop('checked', false);
  // inputToSelect.prop('checked', true);

  // formVariantInputs.trigger('change');
  // let forms = document.querySelectorAll('form[action="/cart/add"]');
  // forms.forEach(function(form) {
  //   form.dispatchEvent(new Event('change'));
  //   console.log("Change event dispatched");
  // });
}

function updateMainImage() {
  let selectedSizeImageSrc = $('.radio-group--size:checked').closest('.size-option').find('.radio-option-group__label-text img').attr('src');
  $('.widget-body-inner__image img').attr('src', selectedSizeImageSrc);
}

function handleDrop(e) {
  let dt = e.dataTransfer
  let files = dt.files


}